import gql from 'graphql-tag';

const GET_ORGANIZATIONS_AVAILABLE_LICENSES = gql`
  query getOrganizationAvailableLicenses($organizationId: Int!) {
    organization(where: { id: $organizationId }) {
      id
      rootOrganization {
        id
        licenseUsage {
          assignedCount
          availableCount
          siteLicensed
          totalCount
          overageStats {
            assignedCount
            availableCount
            overageLimitCount
            totalCount
          }
          product {
            id
            code
            name
            type
            family {
              id
              code
              name
            }
          }
          productCurriculum {
            id
            code
          }
        }
      }
    }
  }
`;

export default GET_ORGANIZATIONS_AVAILABLE_LICENSES;
